import { useState } from 'react';
import {
  Button,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddTopicDialog from './dialog/topic/AddTopicDialog';
import GenerateLessonsDialog from './dialog/generate-lessons/GenerateLessonsDialog';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lessonLevel: 1,
  subjectId: 0,
};

const AddTopicAction = (props) => {
  const {
    subjectId,
    courseId,
    unitId,
    lessonLevel,
  } = { ...defaultProps, ...filterUndefined(props) };
  const [openDialog, setOpenDialog] = useState(false);

  const [openGenerateLessonDialog, setOpenGenerateLessonDialog] = useState({
    open: false,
    topicId: null,
  });

  return (
    <>
      <Button
        variant='contained'
        className='btn-green-background add-button'
        onClick={() => { setOpenDialog(true); }}
        disabled={!courseId || !lessonLevel}
        startIcon={<EditIcon />}
        data-test='add-topic-action'
      >
        Add Topic
      </Button>

      {openDialog && (
        <AddTopicDialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
          }}
          onSaveSuccess={(newTopics) => {
            setOpenDialog(false);
            setOpenGenerateLessonDialog({
              open: true,
              topicId: newTopics.id,
            });
          }}
          courseId={courseId}
          unitId={unitId}
          lessonLevel={lessonLevel}
        />
      )}

      {openGenerateLessonDialog.open && (
        <GenerateLessonsDialog
          open={openGenerateLessonDialog.open}
          onClose={() => {
            setOpenGenerateLessonDialog({
              open: false,
            });
          }}
          subjectId={subjectId}
          courseId={courseId}
          unitId={unitId}
          topicId={openGenerateLessonDialog.topicId}
          lessonLevel={lessonLevel}
        />
      )}

    </>
  );
};

export default AddTopicAction;
